import { render } from "./App.vue?vue&type=template&id=47be28ac&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=47be28ac&scoped=true&lang=scss"
import "./App.vue?vue&type=style&index=1&id=47be28ac&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47be28ac"]])

export default __exports__